module.exports = __webpack_public_path__ + "img/LBNorm_Gray_1280x1010.e20e9be4.jpg";